import { render, staticRenderFns } from "./ModalAttentionEmail.vue?vue&type=template&id=76f3b20c&"
import script from "./ModalAttentionEmail.vue?vue&type=script&lang=js&"
export * from "./ModalAttentionEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalAttentionEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports